/* eslint-disable typescript-sort-keys/string-enum */

import { SelectOption } from 'app/components/v2/components/Select';

export type EditPayorDocumentType =
  'authorizedSignatories' |
  'dataUseAgreement' |
  'miscellaneous' |
  'paymentProcessingAgreement' |
  'scheduleA' |
  'scheduleB' |
  'scheduleC';

export enum PayorSubTypeIds {
  Brokerage = 1,
  ManagedTrans,
}

export enum PayorTypeIds {
  TriumphPayBroker = 1,
  FactoredBroker,
  Shipper,
}

export enum CountryIds {
  US = 'United States',
  CA = 'Canada',
}

export const editPayorDocumentLabelIds: Record<EditPayorDocumentType, null | number> = {
  authorizedSignatories: 1,
  dataUseAgreement: 6,
  miscellaneous: null,
  paymentProcessingAgreement: 2,
  scheduleA: 3,
  scheduleB: 4,
  scheduleC: 5,
};

export const editPayorDocumentLabelNames: Record<EditPayorDocumentType, string> = {
  authorizedSignatories: 'Authorized Signatories',
  dataUseAgreement: 'Data Use Agreement',
  miscellaneous: 'Miscellaneous',
  paymentProcessingAgreement: 'Payment Processing Agreement',
  scheduleA: 'Schedule A',
  scheduleB: 'Schedule B',
  scheduleC: 'Schedule C',
};

export const editPayorDocumentLabelNameMap: Record<number, EditPayorDocumentType> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  0: 'miscellaneous',
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  [editPayorDocumentLabelIds.authorizedSignatories!]: 'authorizedSignatories',
  [editPayorDocumentLabelIds.paymentProcessingAgreement!]: 'paymentProcessingAgreement',
  [editPayorDocumentLabelIds.scheduleA!]: 'scheduleA',
  [editPayorDocumentLabelIds.scheduleB!]: 'scheduleB',
  [editPayorDocumentLabelIds.scheduleC!]: 'scheduleC',
  [editPayorDocumentLabelIds.dataUseAgreement!]: 'dataUseAgreement',
  /* eslint-enable @typescript-eslint/no-non-null-assertion */
  /* eslint-enable @typescript-eslint/naming-convention */
};

export enum DraftSchedule {
  Daily = 'Daily',
  WeeklyStandard = 'Weekly - Standard',
  WeeklyImmediate = 'Weekly - Immediate',
}

export const payorDivisionOptions: SelectOption[] = [
  {
    label: 'Brokerage',
    value: PayorSubTypeIds.Brokerage,
  },
  {
    label: 'Manage trans',
    value: PayorSubTypeIds.ManagedTrans,
  },
];
